export default __webpack_public_path__ + "static/media/dual-branding-logo.f0983d61.png";